import axios from "axios";
import GetServerAddress from "../../functions/GetServerAddress";

export function Get_limited_Choose_Fields_From_MongoDB_With_Search_And_Regex_With_Sort(
  dbName,
  collctiontext,
  search,
  RegexSearch,
  limit,
  setdata,
  sort,
  fields,
  logout
) {
  // Choose fields like this:
  // { item: 1, status: 1, _id: 0 }
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() +
          "api/staff/Get_limited_Choose_Fields_From_MongoDB_With_Search_And_Regex_With_Sort",
        {
          dbName: dbName,
          collctiontext: collctiontext,
          search: search,
          limit: limit,
          fields: fields,
          sort: sort,
          RegexSearch: RegexSearch,
          //[{Field: "Field", Value: "Value"}, {Field: "Field", Value: "Value"}]
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
          },
        }
      );
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return; // Stop further execution in case of invalid auth token
      }
      console.log("Response Data: ", response);
      setdata(response.data.data); // Update your state with the fetched data
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };

  fetchData();
} // Empty dependency array means this effect runs only once
